import React from "react";
import { BSPSubtext } from "../BSPSubtext";
import {
  Body,
  TopContainer,
  Container,
  TopContent,
  LogoContainer,
  Content,
  CopyrightContainer,
} from "./styles";
import { MainForm } from "./components/MainForm";
import { SegmentPropFunctions } from "../../segment";
import { Logo } from "../Logo";

type Props = {
  signUpVerification?: (initId: string) => void;
  onSubmitVerificationCode: (
    OTP: string
  ) => Promise<void | { mfaRequired?: boolean }>;
  onSendVerificationCode: (profileIdentifier: string) => Promise<void>;
  isSsoEnabled: boolean;
  onSsoLogin?: (email: string) => Promise<void>;
  onGoogleAuthSuccess: (idToken: string, email: string) => Promise<void>;
  onGoogleAuthFailure?: (error: Error) => Promise<void>;
  googleApiKey: string;
  googleMapsApiKey: string;
  segment: SegmentPropFunctions;
  source: "PWA" | "ADMIN";
};

export function Login({
  onSubmitVerificationCode,
  onSendVerificationCode,
  signUpVerification,
  isSsoEnabled,
  onSsoLogin,
  onGoogleAuthSuccess,
  onGoogleAuthFailure,
  googleApiKey,
  googleMapsApiKey,
  segment,
  source,
}: Props) {
  return (
    <Body>
      <Container>
        <TopContainer>
          <TopContent>
            <LogoContainer>
              <Logo />
            </LogoContainer>
          </TopContent>
          <Content>
            <MainForm
              source={source}
              segment={segment}
              googleApiKey={googleApiKey}
              googleMapsApiKey={googleMapsApiKey}
              onSendVerificationCode={onSendVerificationCode}
              onSubmitVerificationCode={onSubmitVerificationCode}
              signUpVerification={signUpVerification}
              isSsoEnabled={isSsoEnabled}
              onSsoLoginOptionSelected={onSsoLogin}
              onGoogleAuthSuccess={onGoogleAuthSuccess}
              onGoogleAuthFailure={onGoogleAuthFailure}
            />
          </Content>
        </TopContainer>
        <CopyrightContainer>
          <BSPSubtext>
            Copyright &copy; {new Date().getFullYear()} Reps.ai. All rights
            reserved.
          </BSPSubtext>
          <BSPSubtext>
            reps.ai@
            {process.env.NEXT_PUBLIC_VERSION ||
              process.env.VERSION ||
              "unknown-version"}
          </BSPSubtext>
        </CopyrightContainer>
      </Container>
    </Body>
  );
}
